import { render, staticRenderFns } from "./PayPlanSmallCard.vue?vue&type=template&id=0ab0c8e2&scoped=true"
import script from "./PayPlanSmallCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PayPlanSmallCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayPlanSmallCard.vue?vue&type=style&index=0&id=0ab0c8e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab0c8e2",
  null
  
)

export default component.exports